/**
 * Computes the Y-axis domain (minimum and maximum values) with added padding at the top.
 * This is useful for ensuring that chart elements (e.g., tick labels, bars, or lines)
 * are not clipped at the upper bound of the chart.
 * The padding is applied as a percentage of the data range.
 */
export const computeYDomainWithPadding = (domain: [number, number]) => {
  const [min, max] = domain;
  // add 5% padding
  return [min, max * 1.05];
};

/**
 * Returns an array of numeric values representing the Y-axis positions
 * where tick marks (lines and labels) should be rendered.
 * These values correspond to data values on the Y-axis,
 * not pixel positions on the screen.
 */
export const computeYAxisTicks = (domain: [number, number]): number[] => {
  const yAxisBottomTick = domain[0];
  const yAxisTopTick = domain[1];
  const yAxisMiddleTick = (yAxisBottomTick + yAxisTopTick) / 2;

  return [yAxisBottomTick, yAxisMiddleTick, yAxisTopTick];
};
